
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M31.358.693h4.076v5.453c7.293.04 14.58-.076 21.867.04 1.554-.157 2.774 1.05 2.63 2.604.116 13.428-.026 26.863.069 40.29-.068 1.378.136 2.905-.661 4.125-.996.708-2.284.62-3.442.674-6.824-.033-13.64-.02-20.463-.02v5.453h-4.26C20.8 57.417 10.398 55.68.004 53.86c-.008-15.902 0-31.804 0-47.7C10.451 4.332 20.907 2.554 31.357.693z","fill":"#2A5699"}}),_c('path',{attrs:{"d":"M35.434 8.19h22.493v43.625H35.434v-5.453h17.722v-2.727H35.434v-3.408h17.722V37.5H35.434v-3.408h17.722v-2.726H35.434v-3.408h17.722V25.23H35.434v-3.408h17.722v-2.727H35.434v-3.408h17.722v-2.726H35.434V8.19zM14.085 20.235c1.295-.075 2.59-.13 3.885-.198a846.974 846.974 0 002.815 13.776c.77-4.731 1.623-9.448 2.447-14.171 1.363-.048 2.727-.123 4.083-.205-1.54 6.605-2.89 13.265-4.574 19.829-1.138.593-2.842-.028-4.192.068-.907-4.512-1.963-8.998-2.774-13.53-.798 4.403-1.834 8.765-2.747 13.142-1.309-.068-2.624-.15-3.94-.239C7.955 32.71 6.627 26.751 5.57 20.74c1.165-.054 2.338-.102 3.503-.143.702 4.342 1.5 8.664 2.113 13.012.963-4.457 1.944-8.915 2.898-13.373z","fill":"#fff"}})])
          )
        }
      }
    